var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("AdvanceTable", {
    directives: [
      {
        name: "loading",
        rawName: "v-loading",
        value: _vm.isLoading,
        expression: "isLoading",
      },
    ],
    ref: "advanceTable",
    attrs: {
      url: "login-logs",
      height: _vm.window.height - 310,
      columns: _vm.columns,
      pageOptions: [50, 100, 200],
      defaultPageSize: 50,
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v(" " + _vm._s(_vm.$t("Login Logs")) + " ")]
        },
        proxy: true,
      },
      {
        key: "cell(origin_countries)",
        fn: function (row) {
          return [
            _vm._v(
              " " +
                _vm._s(
                  row.value
                    .map(function (c) {
                      return c.countryCode
                    })
                    .join(", ")
                ) +
                " "
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }